import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Box } from '@mui/material'
import { Container } from '../../../components'

export const useStyles = makeStyles(({ breakpoints, palette, spacing, typography }) => ({
  root: {
    display: 'grid',
    [breakpoints.up('md')]: {
      gridTemplateColumns: '1fr 660px 1fr'
    }
  },
  container: {
    paddingBottom: spacing(2)
  },
  viewer: {
    '& img': {
      maxHeight: '100%',
      maxWidth: '100%',
      objectFit: 'contain'
    }
  }
}))

export const SkillBiteContainer = ({ children }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <div />
      <Box display='flex' mt={4} flexDirection='column'>
        <Container
          maxContentWidth={668}
          inset={2}
          disableGutters
          classes={{ content: classes.viewer }}
          className={classes.container}
        >
          {children}
        </Container>
      </Box>
      <div />
    </Box>
  )
}
